module.exports = __webpack_public_path__ + "img/Subtract-certidao.6d7b96d7.svg";